import React from 'react';

export const StarSvg = props => 
    <svg x="0px" y="0px" viewBox="0 0 30 30">
        <path d="M.4,14.6C3.52,13.74,6.68,13,9.75,12a3.76,3.76,0,0,0,2.08-2.1c1-3.07,1.76-6.23,3.06-9.42.84,3,1.76,6,2.46,9.07A3.06,3.06,0,0,0,20,12.17c3.07.69,6.09,1.63,9.9,2.68-3.8,1-6.88,2-10,2.71A2.89,2.89,0,0,0,17.4,20c-.73,3.14-1.67,6.24-2.71,10-1-3.81-1.8-7-2.85-10.13A4,4,0,0,0,9.6,17.69c-3-1-6.2-1.77-9.31-2.61Z"/>
    </svg>